import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const label = (value) => (value || "upcoming").replaceAll("_", " ");

export const ProjectActionCenter = ({
  items,
  projectId,
}) => {
  const permitItems = items.filter((item) => item.item_type === "permit_renewal");

  if (!permitItems.length) {
    return null;
  }

  return (
    <section className="command-panel command-action-panel" data-testid="command-action-center">
    <div className="command-panel-heading">
      <div>
        <span className="operations-kicker">Action Queue</span>
        <h2>Permit actions</h2>
      </div>
      <Link data-testid="command-open-project-action-queue" to={`/action-queue?project_id=${projectId}`}>
        Open Action Queue
        <ArrowUpRight size={14} />
      </Link>
    </div>
    <div className="command-action-list" data-testid="command-open-action-list">
      {permitItems.slice(0, 5).map((item) => (
        <article className={`command-action-row ${item.item_type === "permit_renewal" ? "permit-renewal" : ""}`} data-testid={`command-action-${item.id}`} key={item.id}>
          <div>
            <small>{item.item_type === "permit_renewal" ? "System Generated – Permit Renewal" : `Manual · ${label(item.item_type)}`}</small>
            <strong>{item.title}</strong>
            <span>{item.assignee || "Owner/Admin review required"} · {item.permit_expires_on || item.due_at || "No due date"}</span>
          </div>
          <span className={`command-action-alert ${item.alert_state}`}>{label(item.alert_state)}</span>
          {item.item_type === "permit_renewal" && item.permit_id && (
            <Link data-testid={`command-open-permit-${item.id}`} to={`/permits-locates?permit_id=${item.permit_id}`}>
              Open Permit
            </Link>
          )}
        </article>
      ))}
    </div>
    </section>
  );
};